/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_NoteInputs */

const en_gc_resources_guide_analysis_note = /** @type {(inputs: Gc_Resources_Guide_Analysis_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart and PivotTable controls can change between alpha releases. This guide describes the desktop workflow; the browser workspace offers a simpler editing experience.`)
};

const zh_gc_resources_guide_analysis_note = /** @type {(inputs: Gc_Resources_Guide_Analysis_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图表和数据透视表控件可能随 Alpha 版本变化。本指南介绍桌面操作流程，浏览器工作空间提供较简化的编辑体验。`)
};

/**
* | output |
* | --- |
* | "Chart and PivotTable controls can change between alpha releases. This guide describes the desktop workflow; the browser workspace offers a simpler editing ex..." |
*
* @param {Gc_Resources_Guide_Analysis_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_note = /** @type {((inputs?: Gc_Resources_Guide_Analysis_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_note(inputs)
	return zh_gc_resources_guide_analysis_note(inputs)
});
export { gc_resources_guide_analysis_note as "gc.resources.guide.analysis.note" }